export var BID_TYPE;
(function (BID_TYPE) {
    BID_TYPE["MV"] = "mv";
    BID_TYPE["MC"] = "mc";
    BID_TYPE["MC_WITH_TAG"] = "mcWithTag";
})(BID_TYPE || (BID_TYPE = {}));
/** 免单卡金额（恒为 288，小手切图等素材也写死 288）：标题展示用，不走后端/运营配置 */
export const FREE_CARD_AMOUNT = 288;
export const FREE_CARD_UNUSED_VAP = {
    mp4: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647369978-video.mp4',
    configJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647369978-config.json',
    mtapConfigJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647369978-mtap.json'
};
export const FREE_CARD_USED_VAP = {
    mp4: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647445777-video.mp4',
    configJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647445777-config.json',
    mtapConfigJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647445777-mtap.json'
};
export const ASSIST_MODAL_VAP = {
    mp4: 'https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1747821327814-video.mp4',
    configJson: 'https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1747821327814-config.json',
    mtapConfigJson: 'https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1747821327814-mtap.json'
};
export const CITY_SELECTOR_CITY_VAP = {
    mp4: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647175704-video.mp4',
    configJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647175704-config.json',
    mtapConfigJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1775647175704-mtap.json'
};
/** 城市 item 标签徽章背景图（200×54px） */
export const CITY_TAG_BADGE_BG = 'https://img.meituan.net/makerjiulv/0a7207551aa0f2a9bfc452e6ba69284f1474.png';
export const CITY_ITEM_HAND_VAP = {
    mp4: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1770349057101-video.mp4',
    configJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1770349057101-config.json',
    mtapConfigJson: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1770349057101-mtap.json'
};
export const BID_MAP = {
    COMPONENT_MV: 'b_daodian_lowcode_mqc3qxzy_mv',
    /** 主卡片曝光 */
    CITY_EXPLORE_MAIN_CARD_MV: 'b_daodian_lowcode_loagfl59_mv',
    CITY_SELECTOR_MODAL_MV: 'b_daodian_lowcode_extxxg37_mv',
    /** 城市选择 - 曝光 */
    CITY_SELECTOR_MV: 'b_daodian_lowcode_wcrf2ac8_mv',
    /** 城市选择 - 点击 */
    CITY_SELECT_MC: 'b_daodian_lowcode_20tyjppd_mc',
    /** 换一批 */
    REFRESH_CITIES_MC: 'b_daodian_lowcode_f4n9dugh_mc',
    /** 城市筛选 */
    CITY_SEARCH_MC: 'b_daodian_lowcode_2l0wyhmh_mc',
    /** 地标 - 点击 */
    LANDMARK_CLICK_MC: 'b_daodian_lowcode_4i3f8fha_mc',
    /** 邀请按钮 - 曝光 */
    INVITE_BUTTON_MV: 'b_daodian_lowcode_vn3edml7_mv',
    /** 邀请按钮 - 点击 */
    INVITE_BUTTON_MC: 'b_daodian_lowcode_8hk54w4v_mc',
    /** 奖励按钮&记录按钮 - 点击 */
    REWARD_BUTTON_MC: 'b_daodian_lowcode_9k2k0o4w_mc',
    /** 免单卡弹窗 - 曝光 */
    FREE_CARD_MODAL_MV: 'b_daodian_lowcode_h2zvtaug_mv',
    /** 助力弹窗 - 曝光 */
    ASSIST_MODAL_MV: 'b_daodian_lowcode_qtcl7roo_mv',
    /** 免单卡 - 去使用 */
    FREE_CARD_USE_MC: 'b_daodian_lowcode_8lgh3dqj_mc',
    /** 券弹窗 - 曝光 */
    COUPON_MODAL_MV: 'b_daodian_lowcode_zwbohvay_mv',
    /** 助力弹窗 - 曝光 */
    ASSIST_MODAL_JOIN_ACTIVITY_BUTTON_MC: 'b_daodian_lowcode_kloq1qz8_mc',
    /** 地标详情弹窗 - 曝光 */
    LANDMARK_DETAIL_MV: 'b_daodian_lowcode_mjcaarxr_mv',
    /** 主卡片预参与状态重选城市按钮点击 */
    CITY_EXPLORE_MAIN_CARD_RESELECT_CITY_MC: 'b_daodian_lowcode_n47hfytc_mc',
    /** 主卡片预参与状态确认参与按钮点击 */
    CITY_EXPLORE_MAIN_CARD_CONFIRM_PARTICIPATE_MC: 'b_daodian_lowcode_sxxlc9u3_mc',
    /** 主卡片免单卡使用规则点击 */
    CITY_EXPLORE_MAIN_CARD_FREE_CARD_RULE_MC: 'b_daodian_lowcode_ndk6ypnq_mc',
    /** 主卡片活动过期预约按钮点击 */
    CITY_EXPLORE_MAIN_CARD_EXPIRED_RESERVE_MC: 'b_daodian_lowcode_j55tthrt_mc',
    /** 主卡片活动过期中奖名单点击 */
    CITY_EXPLORE_MAIN_CARD_EXPIRED_WINNER_LIST_MC: 'b_daodian_lowcode_1ansd446_mc',
    // R007：任务半页弹窗埋点。TODO：bid 为占位值，待灵犀申请后替换
    /** 任务入口曝光 */
    TASK_ENTRY_MV: 'b_daodian_lowcode_2zvhkv6e_mv',
    /** 任务入口点击 */
    TASK_ENTRY_MC: 'b_daodian_lowcode_ccrq1snh_mc',
    /** 单个任务项曝光（带 task_item_id/task_type/biz_line） */
    TASK_ITEM_MV: 'b_daodian_lowcode_v5ca1xry_mv',
    /** 单个任务项点击（带 task_item_id/task_type/biz_line/button_state） */
    TASK_ITEM_MC: 'b_daodian_lowcode_1d7hi0i1_mc'
};
